import { render } from "./GameTypeSelection.vue?vue&type=template&id=10fbeeae"
import script from "./GameTypeSelection.vue?vue&type=script&lang=js"
export * from "./GameTypeSelection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__